/* eslint-disable camelcase */
import { Button, Card, Icon, Typography } from '@equinor/eds-core-react';
import {
  external_link,
  info_circle,
  library,
  settings,
} from '@equinor/eds-icons';
import { useNavigate } from 'react-router-dom';
import * as Styled from './Home.styled';
import * as StyledCard from '../../styles/Card/Card.styled';
import pepmWordmark from '../../assets/pepm letters.svg';

interface TileConfig {
  title: string;
  description: string;
  icon: typeof library;
  action: () => void;
  buttonLabel: string;
  external?: boolean;
}

export const Home = () => {
  const navigate = useNavigate();

  const tiles: TileConfig[] = [
    {
      title: 'Model Library',
      description:
        'Browse and manage digital conceptual models. Import, inspect, and compute parameters for your models.',
      icon: library,
      action: () => navigate('/models'),
      buttonLabel: 'Go to Model Library',
    },
    {
      title: 'Scenario Builder',
      description:
        'Create and configure scenarios based on templates. Set parameters and run orchestrations.',
      icon: settings,
      action: () => navigate('/scenario-builder'),
      buttonLabel: 'Go to Scenario Builder',
    },
    {
      title: 'User Manual',
      description:
        'Learn about PEPM features, workflows, and how to get started with the application.',
      icon: info_circle,
      action: () =>
        window.open(
          'https://statoilsrm.sharepoint.com/sites/PEPM',
          '_blank',
          'noopener',
        ),
      buttonLabel: 'Go to User Manual',
    },
    {
      title: 'Peacock',
      description:
        'Access the Peacock portal for analogue data exploration, filtering, and benchmarking.',
      icon: external_link,
      action: () =>
        window.open('https://peacock.equinor.com', '_blank', 'noopener'),
      buttonLabel: 'Go to Peacock',
      external: true,
    },
  ];

  return (
    <Styled.HomeWrapper>
      <div>
        <Styled.Wordmark src={pepmWordmark} alt="PEPM" />
        <Styled.Subtitle>
          Equinor’s hub to generate digital geological process models and
          extract, manage, and analyse reservoir modelling parameters from the
          models.
        </Styled.Subtitle>
      </div>

      <Styled.CardGrid>
        {tiles.map((tile) => (
          <Styled.CardRow key={tile.title}>
            <Styled.CardImage>
              <Icon data={tile.icon} size={48} color="#007079" />
            </Styled.CardImage>
            <Card>
              <Card.Header>
                <Card.HeaderTitle>
                  <Typography variant="h4" as="h3">
                    {tile.title}
                  </Typography>
                </Card.HeaderTitle>
              </Card.Header>
              <StyledCard.Content>
                <Typography variant="body_long">{tile.description}</Typography>
                <Button variant="outlined" onClick={tile.action}>
                  {tile.buttonLabel}
                </Button>
              </StyledCard.Content>
            </Card>
          </Styled.CardRow>
        ))}
      </Styled.CardGrid>
    </Styled.HomeWrapper>
  );
};
